"use client";

import { c as _c } from "react/compiler-runtime";
import { CreateTaskModal } from "@/app/[tenant]/(console)/tasks/modals/create-task-modal";
import { DocumentSummary } from "@/types/document";
interface RequestDocumentSignOffModalProps {
  document: DocumentSummary;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Wraps {@link CreateTaskModal} pre-filled to route a document to one provider
 * for review and sign-off. Mirrors CreateFaxTaskDialog:
 * an ordinary task (assignment + the single TASK_ASSIGNED alert) that targets a
 * document via `targetDocumentId`, so the assignee deep-links straight to it and
 * signing off the document auto-completes the task. The patient pre-fills from
 * the document's record.
 */
export default function RequestDocumentSignOffModal(t0) {
  const $ = _c(7);
  const {
    document,
    open,
    onOpenChange
  } = t0;
  const t1 = `Sign off document — ${document.title}`;
  const t2 = `Please review and sign off this document: ${document.title}`;
  let t3;
  if ($[0] !== document.id || $[1] !== document.patientId || $[2] !== onOpenChange || $[3] !== open || $[4] !== t1 || $[5] !== t2) {
    t3 = <CreateTaskModal open={open} onOpenChange={onOpenChange} defaultTitle={t1} defaultDescription={t2} defaultPatientId={document.patientId} requireAssignee={true} targetDocumentId={document.id} />;
    $[0] = document.id;
    $[1] = document.patientId;
    $[2] = onOpenChange;
    $[3] = open;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}